import React from "react";
import { Col, Row, Button, InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { BankInfoAPI } from "../../Utils/Api/UserProfile";
import { useEffect } from "react";
import { userId } from "../../Utils/LocalStorage";
import Loader from "../../Components/Loader/Loader";
import { onlyNumberCheck } from "../../ConditionChecks/ConditionChecks";
import { toast } from "react-toastify";
import { MdEdit } from "react-icons/md";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";

const MyProfileEditBankInfo = () => {
  const [loading, setLoading] = useState(false);
  const [userBankData, setUserBankData] = useState([]);
  const [editFlag, setEditFlag] = useState(false);

  const [userInput, setUserInput] = useState({
    AcccountHolderName: userBankData?.account_holder_name,
    AcccountNumber: userBankData?.account_number,
    BankName: userBankData?.bank_name,
    RoutingNumber: userBankData?.routing_number,
    // AcccountHolderName: "",
    // AcccountNumber: "",
    // BankName: "",
    // RoutingNumber: "",
  });

  const [err_Display, setErr_Display] = useState({
    errAcccountHolderName: "",
    errAcccountNumber: "",
    errBankName: "",
    errRoutingNumber: "",
  });

  const [editInputFlag, setEditInputFlag] = useState({
    editFlagAcccountHolderName: false,
    editFlagAcccountNumber: false,
    editFlagBankName: false,
    editFlagRoutingNumber: false,
  });

  const CancelHandler = () => {
    setEditFlag(false);
    setErr_Display(() => {
      return {
        errAcccountHolderName: "",
        errAcccountNumber: "",
        errBankName: "",
        errRoutingNumber: "",
      };
    });
    setUserInput(() => {
      return {
        AcccountHolderName: userBankData.account_holder_name
          ? userBankData.account_holder_name
          : "",
        AcccountNumber: userBankData.account_number
          ? userBankData.account_number
          : "",
        BankName: userBankData.bank_name ? userBankData.bank_name : "",
        RoutingNumber: userBankData.routing_number
          ? userBankData.routing_number
          : "",
      };
    });
  };

  const onEdit = () => {
    setEditFlag(true);
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  const onAccHolderName = (e) => {
    setUserInput((ps) => {
      return { ...ps, AcccountHolderName: e.target.value };
    });
    setErr_Display((ps) => {
      return { ...ps, errAcccountHolderName: "" };
    });
    setEditInputFlag((ps) => {
      return { ...ps, editFlagAcccountHolderName: true };
    });
  };

  const onAccNumber = (e) => {
    setUserInput((ps) => {
      return { ...ps, AcccountNumber: e.target.value };
    });
    setErr_Display((ps) => {
      return { ...ps, errAcccountNumber: "" };
    });
    setEditInputFlag((ps) => {
      return { ...ps, editFlagAcccountNumber: true };
    });
  };

  const onBankName = (e) => {
    setUserInput((ps) => {
      return { ...ps, BankName: e.target.value };
    });
    setErr_Display((ps) => {
      return { ...ps, errBankName: "" };
    });
    setEditInputFlag((ps) => {
      return { ...ps, editFlagBankName: true };
    });
  };

  const onRoutingNumber = (e) => {
    setUserInput((ps) => {
      return { ...ps, RoutingNumber: e.target.value };
    });
    setErr_Display((ps) => {
      return { ...ps, errRoutingNumber: "" };
    });
    setEditInputFlag((ps) => {
      return { ...ps, editFlagRoutingNumber: true };
    });
  };

  // const navigate = useNavigate();
  const Bu_id = userId();

  const SaveHandler = (event) => {
    event.preventDefault();
    let validationcheck = true;
    const AccNumberValidation = onlyNumberCheck(
      editInputFlag.editFlagAcccountNumber === true
        ? userInput.AcccountNumber
        : userBankData.account_number
    );
    const RoutingNoValidation = onlyNumberCheck(
      editInputFlag.editFlagRoutingNumber === true
        ? userInput.RoutingNumber
        : userBankData.routing_number
    );

    if (
      editInputFlag.editFlagAcccountHolderName === true
        ? !userInput.AcccountHolderName
        : !userBankData.account_holder_name
    ) {
      setErr_Display((ps) => {
        return { ...ps, errAcccountHolderName: "Please enter the field" };
      });
      validationcheck = false;
    }

    if (AccNumberValidation.input === "empty") {
      setErr_Display((ps) => {
        return { ...ps, errAcccountNumber: AccNumberValidation.err_display };
      });
      validationcheck = false;
    } else if (AccNumberValidation.input === "invalid") {
      setErr_Display((ps) => {
        return { ...ps, errAcccountNumber: AccNumberValidation.err_display };
      });
      validationcheck = false;
    }

    if (
      editInputFlag.editFlagBankName === true
        ? !userInput.BankName
        : !userBankData.bank_name
    ) {
      setErr_Display((ps) => {
        return { ...ps, errBankName: "Please enter the field" };
      });
      validationcheck = false;
    }

    if (RoutingNoValidation.input === "empty") {
      setErr_Display((ps) => {
        return { ...ps, errRoutingNumber: RoutingNoValidation.err_display };
      });
      validationcheck = false;
    } else if (RoutingNoValidation.input === "invalid") {
      setErr_Display((ps) => {
        return { ...ps, errRoutingNumber: RoutingNoValidation.err_display };
      });
      validationcheck = false;
    }

    if (validationcheck === true) {
      let BankCredentials = {
        bu_id: Bu_id,
        ac_holder_name:
          editInputFlag.editFlagAcccountHolderName === true
            ? userInput.AcccountHolderName
            : userBankData.account_holder_name,
        ac_number:
          editInputFlag.editFlagAcccountNumber === true
            ? userInput.AcccountNumber
            : userBankData.account_number,
        ac_bank_name:
          editInputFlag.editFlagBankName === true
            ? userInput.BankName
            : userBankData.bank_name,
        ac_rounting_number:
          editInputFlag.editFlagRoutingNumber === true
            ? userInput.RoutingNumber
            : userBankData.routing_number,
        api_method: "post",
      };
      UpdateBankInfoAPI(BankCredentials);
    }
  };

  const GetBankInfoAPI = async () => {
    let val = {
      bu_id: parseInt(Bu_id),
      api_method: "get",
    };
    setLoading(true);
    const getBankInfoData = await BankInfoAPI(val);
    setLoading(false);
    setUserBankData(getBankInfoData.data[0]);
  };

  const UpdateBankInfoAPI = async (val) => {
    setLoading(true);
    const getBankInfoData = await BankInfoAPI(val);
    setLoading(false);
    if (getBankInfoData.success === true) {
      toast.success("Updated bank info successfully!", {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setEditFlag(false);
      GetBankInfoAPI();
      window.scrollTo(0, 0);
    }
    if (getBankInfoData.success === false) {
      toast.error(getBankInfoData.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    GetBankInfoAPI();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <Row>
        <Col md="1" lg="2"></Col>
        <Col md="10" lg="8">
          <p className="page-maintitle pr-2">
            <div className="text-right two-btns mr-5">
              <Button className="green-btn mr-2" onClick={onEdit}>
                <MdEdit /> Edit
              </Button>
            </div>
          </p>
          <Form
            onSubmit={SaveHandler}
            className="formmain mx-5 mt-4 signin-row profile-form pb-4"
          >
            <Row>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Acccount Holder Name{" "}
                    <span className="star-required">*</span>
                  </Form.Label>

                  <InputGroup className="edit-border">
                    <Form.Control
                     maxLength={100}
                      type="text"
                      value={
                        editFlag === true
                          ? userInput.AcccountHolderName
                          : userBankData?.account_holder_name
                      }
                      placeholder="Enter Account holder name"
                      className="custom-formcontrol"
                      onChange={onAccHolderName}
                      disabled={editFlag === true ? false : true}
                    />
                  </InputGroup>
                  <ErrorLabel
                    ErrorDisplay={err_Display.errAcccountHolderName}
                  />
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Acccount Number <span className="star-required">*</span>
                  </Form.Label>

                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      maxLength={50}
                      value={
                        editFlag === true
                          ? userInput.AcccountNumber
                          : userBankData?.account_number
                      }
                      placeholder="Enter Account Number"
                      className="custom-formcontrol"
                      onChange={onAccNumber}
                      disabled={editFlag === true ? false : true}
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errAcccountNumber} />
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Bank Name <span className="star-required">*</span>
                  </Form.Label>

                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      maxLength={100}
                      value={
                        editFlag === true
                          ? userInput.BankName
                          : userBankData?.bank_name
                      }
                      placeholder="Enter Bank Name"
                      className="custom-formcontrol"
                      onChange={onBankName}
                      disabled={editFlag === true ? false : true}
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errBankName} />
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Routing Number <span className="star-required">*</span>
                  </Form.Label>

                  <InputGroup className="edit-border">
                    <Form.Control
                      type="text"
                      value={
                        editFlag === true
                          ? userInput.RoutingNumber
                          : userBankData?.routing_number
                      }
                      maxLength={20}
                      placeholder="Enter routing Number"
                      className="custom-formcontrol"
                      onChange={onRoutingNumber}
                      disabled={editFlag === true ? false : true}
                    />
                  </InputGroup>
                  <ErrorLabel ErrorDisplay={err_Display.errRoutingNumber} />
                </Form.Group>
              </Col>
            </Row>
            {editFlag === true ? (
              <div className="text-center small-btns d-flex">
                <Link onClick={CancelHandler}>
                  <p className="view">Cancel</p>
                </Link>
                <Button
                  variant="primary"
                  type="submit"
                  className="green-btn mt-3"
                >
                  Save
                </Button>
              </div>
            ) : (
              <></>
            )}
          </Form>
        </Col>
        <Col md="1" lg="2"></Col>
      </Row>
    </>
  );
};

export default MyProfileEditBankInfo;
